"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _class;
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
/**
 * @description Metrics handles all the call metrics events
 * @export
 * @class Metrics
 */
var Metrics = /*#__PURE__*/function () {
  /**
   * Create Metrics Object
   * @constructor
   * @public
   * @memberof Meetings
   */
  function Metrics() {
    (0, _classCallCheck2.default)(this, Metrics);
    (0, _defineProperty2.default)(this, "webex", void 0);
    if (!Metrics.instance) {
      /**
       * @instance
       * @type {Metrics}
       * @private
       * @memberof Metrics
       */
      Metrics.instance = this;
    }

    // eslint-disable-next-line no-constructor-return
    return Metrics.instance;
  }

  /**
   * Initializes the Metrics singleton with a meeting Collection.
   *
   * @param {Object} webex  webex SDK object
   *
   * @returns {void}
   */
  (0, _createClass2.default)(Metrics, [{
    key: "initialSetup",
    value: function initialSetup(webex) {
      this.webex = webex;
    }

    /**
     * Uploads given metric to the Metrics service as an Behavioral metric.
     * Metadata about the environment such as browser, OS, SDK and their versions
     * are automatically added when the metric is sent.
     *
     * The Metrics service will send an Behavioral metric to InfluxDB for
     * aggregation.
     * See https://confluence-eng-gpk2.cisco.com/conf/display/WBXT/Getting+started+with+Metrics+Service.
     *
     * @param {string} metricName  Name of the metric (measurement) to send
     * @param {Object} metricFields  Key-valye pairs of data or values about this metric
     * @param {Object} metricTags  Key-value pairs of metric metadata
     *
     * @returns {void}
     */
  }, {
    key: "sendBehavioralMetric",
    value: function sendBehavioralMetric(metricName) {
      var metricFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var metricTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.webex.internal.metrics.submitClientMetrics(metricName, {
        type: this.webex.config.metrics.type,
        fields: metricFields,
        tags: metricTags
      });
    }

    /**
     * Flattens an object into one that has no nested properties. Each level of nesting is represented
     * by "_" in the flattened object property names.
     * This function is needed, because Amplitude doesn't allow passing nested objects as metricFields.
     * Use this function for metricFields before calling sendBehavioralMetric() if you want to send
     * nested objects in your metrics.
     *
     * If the function is called with a literal, it returns an object with a single property "value"
     * and the literal value in it.
     *
     * @param {any} payload object you want to flatten
     * @param {string} prefix string prefix prepended to any property names in flatten object
     * @returns {Object}
     */
  }, {
    key: "prepareMetricFields",
    value: function prepareMetricFields() {
      var _this = this;
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var output = {};
      if ((0, _isArray.default)(payload)) {
        payload.forEach(function (item, index) {
          var propName = prefix.length > 0 ? "".concat(prefix, "_").concat(index) : "".concat(index);
          output = _objectSpread(_objectSpread({}, output), _this.prepareMetricFields(item, propName));
        });
        return output;
      }
      if ((0, _typeof2.default)(payload) !== 'object' || payload === null) {
        if (prefix.length > 0) {
          return (0, _defineProperty2.default)({}, prefix, payload);
        }
        return {
          value: payload
        };
      }
      (0, _entries.default)(payload).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        var propName = prefix.length > 0 ? "".concat(prefix, "_").concat(key) : key;
        output = _objectSpread(_objectSpread({}, output), _this.prepareMetricFields(value, propName));
      });
      return output;
    }
  }]);
  return Metrics;
}(); // Export Metrics singleton ---------------------------------------------------
_class = Metrics;
(0, _defineProperty2.default)(Metrics, "instance", void 0);
var instance = new Metrics();
var _default = exports.default = instance;
//# sourceMappingURL=index.js.map
